import React from 'react'
import { FactoredPercentAccuracyTooltip } from 'pages/School/Report'

const LabelWithTooltip = () =>
    <React.Fragment>
        משוקלל
        <div style={{ position: "relative", right: "4px", bottom: "15px" }}>
            <FactoredPercentAccuracyTooltip />
        </div>
    </React.Fragment>

const useTabs = () => {

    return [
        {
            id: 0,
            label: <LabelWithTooltip />,
            width: "80px"
        },
        {
            id: 1,
            label: "גולמי",
        }
    ]

}



export default useTabs
